/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const formatListBulletsRTL = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M20 8.75H4V7.25H20V8.75ZM12.8889 15.75H4V14.25H12.8889V15.75ZM18 17C19.1046 17 20 16.1046 20 15C20 13.8954 19.1046 13 18 13C16.8954 13 16 13.8954 16 15C16 16.1046 16.8954 17 18 17Z" />
	</SVG>
);

export default formatListBulletsRTL;
